export const yarnList = [
    {
        id: 0,
        merge: 'A101',
        yarnType: 'CottonYarn',
        count: 'single 30',
        supplier: 'Nestle'
    },
    {
        id: 1,
        merge: 'B202',
        yarnType: 'PolyesterYarn',
        count: 'double 40',
        supplier: 'Dupont'
    },
    {
        id: 2,
        merge: 'C303',
        yarnType: 'WoolYarn',
        count: 'single 20',
        supplier: 'BASF'
    },
    {
        id: 3,
        merge: 'D404',
        yarnType: 'SilkYarn',
        count: 'triple 50',
        supplier: 'Monsanto'
    },
    {
        id: 4,
        merge: 'E505',
        yarnType: 'NylonYarn',
        count: 'double 35',
        supplier: 'Unilever'
    },
    {
        id: 5,
        merge: 'F606',
        yarnType: 'AcrylicYarn',
        count: 'single 25',
        supplier: 'Procter & Gamble'
    },
    {
        id: 6,
        merge: 'G707',
        yarnType: 'RayonYarn',
        count: 'double 45',
        supplier: 'DuPont'
    }
]

export const yarnType = [
    {
    id: 0,
    name: 'Cotton Yarn',
    value: 'cottonyarn'
    },
    {
    id: 1,
    name: 'Specialist Yarn',
    value: 'specialistyarn'
    },
    {
    id: 2,
    name: 'Polyester Yarn',
    value: 'polyesteryarn'
    }
]

export const getYarnType = (id: number) => {
    const yarn = yarnType.find(yarn => yarn.id === id)
    return yarn?.name
}

export const suppliers = [
    {
        id: 0,
        name: 'Nestle'
    },
    {
        id: 1,
        name: 'Dupont'
    },
    {
        id: 2,
        name: 'BASF'
    },
    {
        id: 3,
        name: 'Monsanto'
    },
    {
        id: 4,
        name: 'Unilever'
    },
    {
        id: 5,
        name: 'Procter & Gamble'
    },
]